import { Box } from '@chakra-ui/react'
import React from 'react'

const Divider = ({
  variant,
  color,
  borderWidth,
  isEditing,
}) => {
  return (
    <Box
      my={isEditing && 4}
      w="full"
      borderBottom={`${borderWidth || '2px'} ${variant || 'solid'}`}
      borderBottomColor={color || 'custom.primary'}
    />
  )
}

export default Divider
